module.exports = __webpack_public_path__ + "img/user-card.83cd92fd.svg";